import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const OfferPagesHeading = ({
  className,
  description = null,
  hideBreadcrumbOnMobile = false,
  title,
  ...rest
}) => (
  <div className={twMerge('mb-4', className)} {...rest}>
    <Breadcrumb className={hideBreadcrumbOnMobile ? 'hidden lg:flex' : 'flex'}>
      <BreadcrumbItem href={LINKS.HOME}>
        {placeholder('breadcrumbs.app')}
      </BreadcrumbItem>
      <BreadcrumbItem>{title}</BreadcrumbItem>
    </Breadcrumb>
    <Heading
      as="h1"
      className={hideBreadcrumbOnMobile && 'mt-5 lg:mt-0'}
      size="size3"
    >
      {title}
    </Heading>
    {description && <Text className="pt-2">{description}</Text>}
  </div>
);

OfferPagesHeading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.string,
  hideBreadcrumbOnMobile: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default OfferPagesHeading;
